// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__PQl7E","image":"Loading_image__a2cVx"};